import { createMaskGeoJSON } from './maskUtils.js';

export function addCustomSources(map, sources) {
    sources.forEach(source => {
      const name = source.name;
      delete source.name;
        map.addSource(name, source);
    });
}

export function addCustomLayers(map, layers) {
    layers.forEach(layer => {
        map.addLayer(layer);
    });
}

export async function addCOGMasks(map, cogSources, layers) {
    for (const source of cogSources) {
      const tileUrl = source.tiles?.[0];
      const [rawBaseUrl, queryPart] = tileUrl.split("/cog/tiles");
      const params = new URLSearchParams(queryPart.split("?")[1]);
      const cogPath = params.get("url");
      if (!cogPath) continue;
  
      const baseUrl = rawBaseUrl.replace(/\/+$/, "");
      const boundsUrl = `${baseUrl}/cog/bounds?url=${encodeURIComponent(cogPath)}`;
  
      try {
        const boundsRes = await fetch(boundsUrl);
        if (!boundsRes.ok) {
          throw new Error(`Bounds request failed: ${boundsRes.status}`);
        }
  
        const { bounds } = await boundsRes.json();
        const geojson = createMaskGeoJSON(bounds);
  
        const maskSourceId = `${source.name}MaskSource`;
        const maskLayerId = `${source.name}MaskLayer`;
  
        map.addSource(maskSourceId, {
          type: "geojson",
          data: geojson
        });
  
        map.addLayer({
          id: maskLayerId,
          type: "fill",
          source: maskSourceId,
          paint: {
            "fill-color": "#ffffff",
            "fill-opacity": 0
          }
        });
  
        const rasterLayer = layers.find((l) => l.source === source.name);
        if (rasterLayer) {
          map.moveLayer(rasterLayer.id, maskLayerId);
        }
  
      } catch (err) {
        console.error(`Failed to add mask for ${source.name}:`, err);
      }
    }
  }
  